import { render, staticRenderFns } from "./StockPageOnlyImport.vue?vue&type=template&id=ac9edd74&scoped=true&"
import script from "./StockPageOnlyImport.vue?vue&type=script&lang=js&"
export * from "./StockPageOnlyImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9edd74",
  null
  
)

export default component.exports